import { useState } from "react";
import { setting, getSetting } from "../services/settingService";

export const useSetting = () => {
  const [error, setError] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const settingPost = async (fullName, gender, theme, language, country) => {
    setIsLoading(true);
    setError(false);
    let response = "Something went wrong, Please try again later!";
    try {
      response = await setting(fullName, gender, theme, language, country);
      setIsLoading(false);
      if (response) {
        return response;
      } else {
        setError(true);
        return "Invalid credentials. Please try again.";
      }
    } catch (error) {
      setIsLoading(false);
      setError(true);
      return "Something went wrong";
    }
  };
  const settingGet = async () => {
    setIsLoading(true);
    setError(false);
    let response = "Something went wrong, Please try again later!";
    try {
      response = await getSetting();
      setIsLoading(false);
      if (response) {
        return response;
      } else {
        setError(true);
        return "Invalid credentials. Please try again.";
      }
    } catch (error) {
      setIsLoading(false);
      setError(true);
      return "Something went wrong";
    }
  };

  return {
    settingPost,
    settingGet,
    isLoading,
    error,
  };
};
